import { ReactNode, createContext, useCallback, useState } from 'react';

export interface ShareModalContextType {
  isOpen: boolean;
  openModal: (props: ShareModalProps) => void;
  closeModal: () => void;
  modalProps: ShareModalProps;
}

export interface ShareModalProps {
  title?: string;
  subtitle?: string;
  CustomComponent?: ReactNode;
  onCopyLinkClick?: () => void;
  onFacebookClick?: () => void;
  onTwitterClick?: () => void;
}

export const ShareModalContext = createContext<ShareModalContextType | undefined>(undefined);

export function ShareModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [modalProps, setModalProps] = useState<ShareModalProps>({});

  const openModal = useCallback((props: ShareModalProps) => {
    setModalProps(props);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setModalProps({});
  }, []);

  return (
    <ShareModalContext.Provider value={{ isOpen, openModal, closeModal, modalProps }}>
      {children}
    </ShareModalContext.Provider>
  );
}
